import React, { useEffect } from 'react';
import { ProtocolMessage } from '../../../types/protocols';
import { useBrand } from '../../../../brands/contexts/BrandContext';
import './ProtocolInstrumentsDialog.scss';

export interface ProtocolInstrumentsDialogProps {
    isOpen: boolean;
    onClose: () => void;
    protocol: ProtocolMessage | null;
    protocolId?: string;
    anchor?: { top: number; left: number } | null;
    onSendToMIS: (protocol: ProtocolMessage, protocolId: string) => void;
    onExportPdf?: (protocol: ProtocolMessage, protocolId: string) => void;
    onExportDocx?: (protocol: ProtocolMessage, protocolId: string) => void;
}

const ProtocolInstrumentsDialog: React.FC<ProtocolInstrumentsDialogProps> = ({
    isOpen,
    onClose,
    protocol,
    protocolId = '',
    anchor,
    onSendToMIS,
    onExportPdf,
    onExportDocx,
}) => {
    const { brandId } = useBrand();

    useEffect(() => {
        const handleEscape = (e: KeyboardEvent) => {
            if (e.key === 'Escape') onClose();
        };
        if (isOpen) {
            document.addEventListener('keydown', handleEscape);
        }
        return () => document.removeEventListener('keydown', handleEscape);
    }, [isOpen, onClose]);

    if (!isOpen) return null;

    const dialogStyle: React.CSSProperties | undefined = anchor
        ? {
            position: 'fixed',
            top: anchor.top,
            left: anchor.left,
        }
        : undefined;

    const handleBackdropClick = (e: React.MouseEvent) => {
        if (e.target === e.currentTarget) onClose();
    };

    const handleSendToMIS = () => {
        if (protocol) {
            onSendToMIS(protocol, protocolId);
            onClose();
        }
    };

    const handleExportPdf = () => {
        if (protocol && onExportPdf) {
            onExportPdf(protocol, protocolId);
            onClose();
        }
    };

    const handleExportDocx = () => {
        if (protocol && onExportDocx) {
            onExportDocx(protocol, protocolId);
            onClose();
        }
    };

    return (
        <div className="protocol-instruments-overlay" onClick={handleBackdropClick}>
            <div
                className="protocol-instruments-dialog"
                style={dialogStyle}
                onClick={e => e.stopPropagation()}
            >
                {brandId === 'budzdorov' && (
                    <>
                        <button type="button" className="protocol-instruments-option" onClick={handleSendToMIS}>
                            Передать в МИС
                        </button>
                        <div className="protocol-instruments-separator" />
                    </>
                )}
                <button type="button" className="protocol-instruments-option" onClick={handleExportPdf}>
                    Сформировать PDF файл
                </button>
                <div className="protocol-instruments-separator" />
                <button type="button" className="protocol-instruments-option" onClick={handleExportDocx}>
                    Сформировать DOCX файл
                </button>
            </div>
        </div>
    );
};

export default ProtocolInstrumentsDialog;
